export default "<p>\n  egroup works!\n</p>\n";